import { HeaderScrollView } from "@-/dev.improve.haniverse.components.ui.header-scroll";
import { useToolbarGridMetrics } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import { LevelSurfacesSkeleton } from "#level-surface-skeleton";

/**
 * Match the catalog's top spacing, reserving toolbar height only when it overlays the content.
 * `pt-1` is the loaded list's 4px gap above its first surface under opaque tab chrome; under a
 * floating toolbar the header-scroll gap floor already exceeds it.
 */
export function LevelSurfacesLoadingPage({
  hasFloatingToolbar = false,
}: {
  hasFloatingToolbar?: boolean;
}) {
  const { height: toolbarHeight } = useToolbarGridMetrics();
  return (
    <HeaderScrollView
      className="flex-1"
      contentContainerClassName="px-1 pt-1 pb-24"
      glassHeaderOverlap={hasFloatingToolbar ? toolbarHeight : undefined}
      headerOverlap={hasFloatingToolbar ? toolbarHeight : 0}
      scrollEnabled={false}
    >
      <LevelSurfacesSkeleton />
    </HeaderScrollView>
  );
}
